// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faDownload, faTimes } from "@fortawesome/free-solid-svg-icons";
// import "./index.css";

// const MediaCard = ({ pdfName, showModal, setShowModal }) => {
//   let pdfFile;

//   try {
//     pdfFile = require(`../../../src/Assets/ElectionLevelPDFs/${pdfName}.pdf`);
//   } catch (err) {
//     console.warn(`PDF not found: ${pdfName}.pdf`);
//     pdfFile = null;
//   }

//   const handleOverlayClick = (e) => {
//     if (e.target.classList.contains("media-modal")) {
//       setShowModal(false);
//     }
//   };

//   return (
//     <>
//       {showModal && (
//         <div className="media-modal" onClick={handleOverlayClick}>
//           <div className="media-modal-content">
//             <button className="media-modal-close" onClick={() => setShowModal(false)}>
//               <FontAwesomeIcon icon={faTimes} />
//             </button>

//             <div className="">
//               {pdfFile ? (
//                 <div>
//                   <iframe src={pdfFile} title="PDF Preview" className="media-preview" frameBorder="0" />
//                 </div>
//               ) : (
//                 <div className="media-modal-body">
//                   <div className="no-file-container">
//                     <div className="no-file-icon">📄</div>
//                     <p className="no-file-text">PDF Not Available</p>
//                     <p className="no-file-subtext">The requested document could not be found.</p>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="media-modal-footer">
//               {pdfFile && (
//                 <a href={pdfFile} download className="media-download-btn">
//                   <FontAwesomeIcon icon={faDownload} /> Download
//                 </a>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default MediaCard;

// // import React from "react";
// // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import { faTimes, faDownload } from "@fortawesome/free-solid-svg-icons";
// // import "./index.css";

// // const FullPdfModal = ({ pdfName, showModal, setShowModal }) => {
// //   if (!showModal) return null;

// //   let pdfFile;
// //   try {
// //     pdfFile = require(`../../../src/Assets/ElectionLevelPDFs/${pdfName}.pdf`);
// //   } catch (err) {
// //     console.warn(`PDF not found: ${pdfName}.pdf`);
// //     pdfFile = null;
// //   }

// //   return (
// //     <div className="pdf-modal-overlay">
// //       <div className="pdf-modal-content">
// //         {/* Close Button */}
// //         <button className="pdf-modal-close" onClick={() => setShowModal(false)}>
// //           <FontAwesomeIcon icon={faTimes} />
// //         </button>

// //         {/* PDF Viewer */}
// //         {pdfFile ? (
// //           <iframe src={`${pdfFile}#toolbar=0&navpanes=0&scrollbar=0`} title="PDF Viewer" className="pdf-modal-iframe" />
// //         ) : (
// //           <div className="no-file-container">
// //             <div className="no-file-icon">📄</div>
// //             <p className="no-file-text">PDF Not Available</p>
// //             <p className="no-file-subtext">The requested document could not be found.</p>
// //           </div>
// //         )}

// //         {/* Download Button */}
// //         {pdfFile && (
// //           <a href={pdfFile} download className="pdf-download-btn">
// //             <FontAwesomeIcon icon={faDownload} /> Download
// //           </a>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default FullPdfModal;





import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import { Narendra_Modi_Election_PDF_API_URL } from "../../Process";

const MediaCard = ({ pdfName, showModal, setShowModal }) => {
  let pdfFile;



  try {
    // pdfFile = require(`../../../src/Assets/ElectionLevelPDFs/${pdfName}.pdf`);

    pdfFile = `${Narendra_Modi_Election_PDF_API_URL + pdfName}.pdf`;
  } catch (err) {
    console.warn(`PDF not found: ${pdfName}.pdf`);
    pdfFile = null;
  }

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("media-modal")) {
      setShowModal(false);
    }
  };

  console.log("sldfjkldsfjklsdfjkfjlskadfa", pdfFile);

  return (
    <>
      {showModal && (
        <div className="media-modal" onClick={handleOverlayClick}>
          <div className="media-modal-content">
            {/* Close Button */}
            <button
              className="media-modal-close"
              onClick={() => setShowModal(false)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            {/* PDF Preview */}
            <div className="media-modal-body">
              {pdfFile ? (
                <iframe
                  src={pdfFile}
                  title="PDF Preview"
                  className="media-preview"
                  frameBorder="0"
                />
              ) : (
                <div className="no-file-container">
                  <div className="no-file-icon">📄</div>
                  <p className="no-file-text">PDF Not Available</p>
                  <p className="no-file-subtext">
                    The requested document could not be found.
                  </p>
                </div>
              )}
            </div>

            {/* Footer with Download */}
            {pdfFile && (
              <div className="media-modal-footer">
                <a href={pdfFile} download className="media-download-btn">
                  <FontAwesomeIcon icon={faDownload} /> Download
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MediaCard;


